import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import * as utils from "../../../components/utils.js";

const BFM_Schema_Editor = (params) => {
    const { fields, onChange } = params;
    const [innerData, setInnerData] = useState({ fields });


    const _build_cell = (params) => {
        const { field, row_data, onChange } = params;

        const _build_input = () => {
            switch (field.fieldType) {
                case "number": {
                    return (<input type="number" className="form-control" onChange={(e) => {
                        row_data[field.fieldName] = e.target.valueAsNumber;
                        if (onChange) onChange(row_data);
                    }}
                        ref={(r) => {
                            if (!r) return;
                            r.valueAsNumber = row_data[field.fieldName];
                        }}
                    ></input>)
                }
                default: {
                    return (<input type="text" className="form-control" value={row_data[field.fieldName]} onChange={(e) => {
                        row_data[field.fieldName] = e.target.value;
                        if (onChange) onChange(row_data);
                    }}></input>)
                }
            }
        }

        return (<td>{_build_input()}</td>);
    }

    const _build_row = (params) => {
        const { field, onChange, onDelete } = params;

        return (<tr>
            <td><input className="form-control" type="text" value={field.fieldName} onChange={(e) => {
                field.fieldName = e.target.value;
                if (onChange) onChange(field);
            }}></input>
                <div class="form-text" >The name used for flows and macros will be: <strong>{utils.code_name(field.fieldName)}</strong></div>
            </td>
            <td>
                <select className="form-select" value={field.fieldType} onChange={(e) => {
                    field.fieldType = e.target.value;
                    if (onChange) onChange(field);
                }}>
                    <option>string</option>
                    <option>number</option>
                    <option>date</option>
                    <option>datetime</option>
                    <option>bool</option>
                </select>
                <div class="form-text" >&nbsp;</div>
            </td>
            <td>
                <input className="form-control" type="text" value={field.description} onChange={(e) => {
                    field.description = e.target.value;
                    if (onChange) onChange(field);
                }}></input>
                <div class="form-text" >&nbsp;</div>
            </td>
            <td style={{ cursor: "pointer", textAlign: "center" }}
                onClick={(e) => {
                    if (onDelete) onDelete(field);
                }}
            ><i class="fa fa-trash me-2"></i></td>
        </tr>)
    }

    const _build_rows = (params) => {
        const { fields, onChange } = params;

        return (<>{fields.map((r) => _build_row({
            field: r, onChange: (e) => {
                if (onChange) onChange(e);
            },
            onDelete: (e) => {
                fields.splice(fields.findIndex(x => x === e), 1);
                if (onChange) onChange(e);
            }
        }))}</>);
    }

    const _build_table = (params) => {
        return (<><table class="table">
            <thead>
                <th>Name</th>
                <th>Type</th>
                <th>Description</th>
                <th></th>
            </thead>
            <tbody>
                {_build_rows({
                    fields: innerData.fields, onChange: (e) => {
                        setInnerData({
                            fields: innerData.fields
                        });
                        if (onChange) onChange(innerData.fields);
                    }
                })}
            </tbody>
        </table>
            <div class="d-grid gap-2"> <button type="button" class="btn btn-primary" onClick={(e) => {
                innerData.fields.push({ fieldName: "New field", fieldType: "string" });
                setInnerData({
                    fields: innerData.fields
                });
            }}>+</button></div>
        </>
        )
    }

    return (<>{_build_table()}</>);
}

export { BFM_Schema_Editor }